import {Component} from 'react';
import {Button, Header, Segment} from 'semantic-ui-react';
import SummaryNotes from './SummaryNotes';
import './CustomiseCoverLetter.scss';
import PropTypes from 'prop-types';

export default class CustomiseCoverLetter extends Component {
  static propTypes = {
    agencyLogo: PropTypes.string,
    colour: PropTypes.string,
    toAddress: PropTypes.string,
    letterContent: PropTypes.string,
    fromAddress: PropTypes.string,
    defaultLetterContent: PropTypes.string.isRequired,
    defaultAddressFrom: PropTypes.string.isRequired,
    defaultAddressTo: PropTypes.string.isRequired,
    onSectionChange: PropTypes.func.isRequired,
    onSaveLetterTemplate: PropTypes.func.isRequired,
  };

  resetTemplate = () => {
    const {defaultLetterContent, defaultAddressFrom, defaultAddressTo, onSectionChange} = this.props;
    onSectionChange({
      key: 'letterContent',
      value: defaultLetterContent,
    });
    onSectionChange({
      key: 'savedLetterContent',
      value: '',
    });
    onSectionChange({
      key: 'fromAddress',
      value: defaultAddressFrom,
    });
    onSectionChange({
      key: 'toAddress',
      value: defaultAddressTo,
    });
  };

  render() {
    const {agencyLogo, colour, fromAddress, toAddress, letterContent, onSectionChange, onSaveLetterTemplate} = this.props;
    return (
      <div className="cover-letter">
        <Header as="h2" className="section-type" style={{fontWeight: 'bold'}} disabled>Cover Letter</Header>
        <Segment style={{padding: '30px'}}>
          <div className="cover-letter-customise">
            {agencyLogo && <img src={agencyLogo} alt="Agency Logo" width="30%" height="30%"/>}
            <svg id="preview">
              <rect id="theme-colour" width="100%" height="5px" fill={colour || '#fff'}/>
            </svg>

            <div className="to-address">
              <SummaryNotes value={toAddress}
                            maxLines={5}
                            enabled
                            onChange={(field, value) => onSectionChange({key: 'toAddress', value})}
              />
            </div>
            <div className="letter-content">
              <SummaryNotes value={letterContent}
                            enabled
                            maxLines={44}
                            onChange={(field, value) => onSectionChange({key: 'letterContent', value})}
              />
              <div className="ui actions">
                <Button primary className="reset-template" onClick={this.resetTemplate}>Reset template</Button>
                <Button primary className="save-template" onClick={onSaveLetterTemplate}>Save template</Button>
              </div>
            </div>

            <div className="from-address">
              <SummaryNotes value={fromAddress}
                            enabled
                            maxLines={7}
                            onChange={(field, value) => onSectionChange({key: 'fromAddress', value})}
              />
            </div>
          </div>
        </Segment>
      </div>
    );
  };
}